module.exports = __webpack_public_path__ + "static/media/03-2-galeria-05-thomas-sabo-mobile@2x.eed66fa9.jpg";